module.exports = __webpack_public_path__ + "static/media/tracking-goal.0555a0f3.svg";